// Smart Sash Admin Panel - Certification Action Buttons Component
// Reusable Edit/Cancel/Save button group for certification management

import React from 'react';
import { Button } from '@/components/common';

export interface ActionButtonsProps {
  isEditMode: boolean;
  isDirty: boolean;
  isSaving: boolean;
  disabled?: boolean;
  onEditClick: () => void;
  onCancelClick: () => void;
  onSaveClick: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  isEditMode,
  isDirty,
  isSaving,
  disabled = false,
  onEditClick,
  onCancelClick,
  onSaveClick,
}) => {
  return (
    <div className="d-flex gap-2" role="group" aria-label="Certification actions">
      {!isEditMode ? (
        <Button
          id="certification-edit-btn"
          variant="primary"
          icon="fas fa-edit"
          onClick={onEditClick}
          disabled={disabled}
          title="Enter edit mode to modify questions"
          aria-label="Edit certification questions"
        >
          Edit
        </Button>
      ) : (
        <>
          <Button
            id="certification-cancel-btn"
            variant="secondary"
            icon="fas fa-times"
            onClick={onCancelClick}
            disabled={isSaving}
            title="Cancel changes (Esc)"
            aria-label="Cancel editing and discard changes"
          >
            Cancel
          </Button>
          <Button
            id="certification-save-btn"
            variant="success"
            icon="fas fa-save"
            onClick={onSaveClick}
            disabled={!isDirty || isSaving}
            loading={isSaving}
            title={isDirty ? 'Save changes (Ctrl+S)' : 'No changes to save'}
            aria-label={isSaving ? 'Saving changes...' : 'Save certification changes'}
          >
            Save
          </Button>
        </>
      )}
    </div>
  );
};

export default ActionButtons;
